module.exports = __webpack_public_path__ + "img/31.06424be.svg";